import { Dispatch, SetStateAction } from 'react';
import { post } from '../../../../scripts';
import { API } from '../../../../data/30pay.api';
import { RequestWithdrawalResult, WithdrawalResult } from '../../../../interfaces';

export const requestWithdrawal = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: { amount: number; IBanNumberId: string; platform: number },
    setData?: Dispatch<SetStateAction<RequestWithdrawalResult | undefined>>,
    onComplete?: () => void,
) => {
    setLoading(true);
    await post<RequestWithdrawalResult>(API.transaction.currencyWithdrawal, data)
        .then((response) => {
            setData && setData(response.value.value);
            onComplete && onComplete();
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => setLoading(false));
};

export const verifyWithdrawalRequest = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    data: { trackingCode: string; otp: string; platformType: number },
    setData: Dispatch<SetStateAction<WithdrawalResult | undefined>>,
    onComplete?: () => void,
) => {
    setLoading(true);
    await post<WithdrawalResult>(API.transaction.verifyCurrencyWithdrawal, data)
        .then((response) => {
            setData(response.value.value);
            onComplete && onComplete();
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => setLoading(false));
};
